import { ApplicationState } from '@/features/publicDatasets/types';

export const getDashboardState = (state: ApplicationState) => ({
  publicPin: state.dashboards.publicPin,
  publicId: state.dashboards.publicId,
  isPublic: state.dashboards.public,
});
